import React, { useEffect } from 'react';
import { MessagePayload } from 'firebase/messaging';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { onMessage, getToken, messaging } from '../firebase-config';
import { environment } from '../environments/environment';
import { client } from '../service/apolloClient';
import { SAVE_USER_DEVICE_TOKEN } from '../graphql/notifications';
import { RootState } from '../store';

export const NotificationSetup: React.FC = () => {
    const { isLoggedIn } = useSelector((state: RootState) => state.user);
    const navigate = useNavigate();
    const saveDeviceToken = async (token: string) => {
        try {
            const input = {
                platform: 'web',
                device_token: token,
            };
            await client.mutate({
                mutation: SAVE_USER_DEVICE_TOKEN,
                variables: { input },
            });
        } catch (err: any) {
            console.error('err in saving device token:', err);
        }
    };
    useEffect(() => {
        if (!isLoggedIn) return;
        const requestPermission = async () => {
            const permission = await Notification.requestPermission();
            if (permission !== 'granted') {
                console.warn('Permission not granted');
                return;
            }
            let token;
            if (environment.NODE_ENV !== 'test') {
                token = await getToken(messaging, {
                    vapidKey: environment.REACT_APP_VAPID_KEY,
                });
                console.warn('FCM Token:', token);
                await saveDeviceToken(token);
            }
        };

        const onPushClick = (type?: number): string => {
            switch (type) {
                case 1:
                case 2:
                    return '/profile-setting';
                case 7:
                case 8:
                    return '/notifications';
                default:
                    return '/home';
            }
        };

        const handleMessage = (payload: MessagePayload) => {
            const { title, body, icon, type } = payload?.data || {};
            if (!title) return;
            const notification = new Notification(title, {
                body,
                icon,
                data: { url: onPushClick(Number(type)) },
            });

            notification.onclick = event => {
                setTimeout(() => notification.close(), 200);
                event.preventDefault();
                const url = notification.data?.url;
                navigate(url);
            };
        };

        requestPermission();
        onMessage(messaging, handleMessage);
    }, [isLoggedIn, navigate]);

    return null;
};
